// Meter types for the property meter register.
//
// Must stay in step with gg-be/config/meter.js, which validates these values
// server-side. There is deliberately no "meter name" -- the type IS the label
// (client decision); the serial number and location distinguish two meters of
// the same type.
export const METER_TYPES = ["Gas", "Electric", "Water"];
